module.exports = __webpack_public_path__ + "static/img/logo.946b5f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 1